var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.eventSlot
    ? _c(
        "v-container",
        [
          _c(
            "v-row",
            [
              _c("v-col", { attrs: { cols: "12", "order-md": "2" } }, [
                _c(
                  "div",
                  { staticClass: "d-flex justify-center justify-md-end" },
                  [
                    _c("action-buttons", {
                      staticClass: "d-flex justify-end",
                      attrs: {
                        state: _vm.editState,
                        permissions: _vm.userPermission,
                        disabled: _vm.isLoading,
                        "is-dirty": _vm.isDirty
                      },
                      on: {
                        save: _vm.handleSave,
                        cancel: _vm.handleCancel,
                        close: _vm.handleClose
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _c(
            "v-form",
            {
              ref: "form",
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c("v-select", {
                        attrs: {
                          rules: [_vm.requiredRule],
                          items: _vm.events,
                          "item-text": "name",
                          "item-value": "id",
                          disabled: _vm.isLoading,
                          label: "Event",
                          outlined: "",
                          dense: ""
                        },
                        on: { change: _vm.eventIdChanged },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: `label`,
                              fn: function() {
                                return [
                                  _c("label-required", {
                                    attrs: { name: "Event" }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.eventSlot.eventId,
                          callback: function($$v) {
                            _vm.$set(_vm.eventSlot, "eventId", $$v)
                          },
                          expression: "eventSlot.eventId"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c("v-select", {
                        attrs: {
                          rules: [_vm.requiredRule],
                          items: _vm.eventSlotTypes,
                          disabled: _vm.isLoading,
                          label: "Event Slot Type",
                          outlined: "",
                          dense: ""
                        },
                        on: { change: _vm.setDefaultDuration },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: `label`,
                              fn: function() {
                                return [
                                  _c("label-required", {
                                    attrs: { name: "Event Slot Type" }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.eventSlot.eventSlotType,
                          callback: function($$v) {
                            _vm.$set(_vm.eventSlot, "eventSlotType", $$v)
                          },
                          expression: "eventSlot.eventSlotType"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          outlined: "",
                          readonly: "",
                          dense: "",
                          label: "Encounter Day and Time"
                        },
                        on: {
                          click: function($event) {
                            _vm.showSlotPicker = true
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: `label`,
                              fn: function() {
                                return [
                                  _c("label-required", {
                                    attrs: { name: "Encounter Day and Time" }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.dayAndTime,
                          callback: function($$v) {
                            _vm.dayAndTime = $$v
                          },
                          expression: "dayAndTime"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "3" } },
                    [
                      _c("time-selector", {
                        attrs: { label: "Duration", "zero-pad-display": false },
                        model: {
                          value: _vm.eventSlot.durationMinutes,
                          callback: function($$v) {
                            _vm.$set(_vm.eventSlot, "durationMinutes", $$v)
                          },
                          expression: "eventSlot.durationMinutes"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.teams,
                          label: "Assigned Team",
                          "item-text": "name",
                          "item-value": "id",
                          outlined: "",
                          dense: "",
                          clearable: ""
                        },
                        model: {
                          value: _vm.eventSlot.teamId,
                          callback: function($$v) {
                            _vm.$set(_vm.eventSlot, "teamId", $$v)
                          },
                          expression: "eventSlot.teamId"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Comment/Notes",
                          outlined: "",
                          dense: "",
                          clearable: ""
                        },
                        model: {
                          value: _vm.eventSlot.comment,
                          callback: function($$v) {
                            _vm.$set(_vm.eventSlot, "comment", $$v)
                          },
                          expression: "eventSlot.comment"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "3" } },
                    [
                      _c("v-checkbox", {
                        attrs: { label: "Is Published" },
                        model: {
                          value: _vm.eventSlot.isPublished,
                          callback: function($$v) {
                            _vm.$set(_vm.eventSlot, "isPublished", $$v)
                          },
                          expression: "eventSlot.isPublished"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "3" } },
                    [
                      _c("v-checkbox", {
                        attrs: { label: "Is Shared With All" },
                        model: {
                          value: _vm.eventSlot.isSharedWithAll,
                          callback: function($$v) {
                            _vm.$set(_vm.eventSlot, "isSharedWithAll", $$v)
                          },
                          expression: "eventSlot.isSharedWithAll"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "900" },
              model: {
                value: _vm.showSlotPicker,
                callback: function($$v) {
                  _vm.showSlotPicker = $$v
                },
                expression: "showSlotPicker"
              }
            },
            [
              _c(
                "v-card",
                { attrs: { tile: "", "data-card": "" } },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { dark: "", color: "secondary" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", dark: "", "data-close": "" },
                          on: {
                            click: function($event) {
                              _vm.showSlotPicker = false
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      ),
                      _c("v-toolbar-title", [
                        _vm._v(
                          _vm._s(_vm.event ? _vm.event.name : "") +
                            " - Select Encounter Time"
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    [
                      _c("event-time-table", {
                        attrs: {
                          event: _vm.event,
                          "slot-data": _vm.slotData,
                          "is-select-mode": ""
                        },
                        on: {
                          slotSelected: (eventDayId, time) =>
                            _vm.handleSlotSelected(eventDayId, time)
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }